const licensePlateErrorPattern = 'Cannot identify license plate in ';
export function isVINVerificationError(err) {
  return Boolean(err?.response?.status === 409 && err?.response?.data?.globalErrors?.find(message => {
    return message.includes(licensePlateErrorPattern);
  }));
}
export const identificationStates = {
  success: 'IDENTIFICATION_SUCCESS',
  failed: 'IDENTIFICATION_ERROR',
  skipped: 'IDENTIFICATION_SKIPED',
  previousFailed: 'PREVIOUS_IDENTIFICATION_ERROR',
  previousSuccess: 'PREVIOUS_IDENTIFICATION_SUCCESS'
};
export function maybeIdentifyVehicle(previousIndetification, carLeadHash, licensePlate, currentStep, identifyOnStep, identifyVehicle) {
  if (!shouldIdentify(previousIndetification, currentStep, identifyOnStep, licensePlate)) {
    return Promise.resolve(false);
  }
  return identifyVehicle(carLeadHash, removeLicensePlateSeparators(licensePlate)).then(() => {
    return true;
  });
}
function shouldIdentify(previousIndetification, currentStep, identifyOnStep, licensePlate) {
  return previousIndetification !== 'IDENTIFICATION_FAILED' && currentStep === identifyOnStep && Boolean(licensePlate);
}
export function removeLicensePlateSeparators(licensePlate) {
  return String(licensePlate).replace(/\s|-/g, '');
}